import type React from 'react'
import {ThemeProvider} from '@primer/react-brand'

/**
 * The App component is used to render content which should be present on _all_ routes within this app
 */
export function App(props: {children?: React.ReactNode}) {
  return <ThemeProvider dir="ltr">{props.children}</ThemeProvider>
}

try{ App.displayName ||= 'App' } catch {}